/**
 * Which prerendered snapshot may be hydrated.
 *
 * Firebase hosting rewrites every unknown path to /index.html — the
 * prerendered LANDING page. Hydrating that for a different route does not
 * fall back cleanly: Vue patches the route into the leftover DOM and the page
 * ends up inside the landing page's first `.mail-float` decoration
 * (position:fixed, opacity:.09) — invisible. So each snapshot carries the
 * path it was rendered for (`data-prerendered`, stamped in main.js before
 * `render-event`) and is used only on that path.
 *
 * Shared by main.js, the pre-paint guard inlined in public/index.html (keep
 * the two rules identical) and the tests.
 */
export const SNAPSHOT_ATTR = "data-prerendered";

/** `/about/` `/about` `//about` → `/about`; `/` `//` `/index.html` → `/`. */
export function normalizePath(path) {
    const collapsed = String(path == null ? "" : path).replace(/\/{2,}/g, "/");
    const noIndex = collapsed.replace(/\/index\.html$/i, "/");
    return noIndex.replace(/\/+$/, "") || "/";
}

/** True only when this markup was prerendered for exactly this path. */
export function canHydrate(snapshotPath, pathname) {
    return Boolean(snapshotPath) && normalizePath(snapshotPath) === normalizePath(pathname);
}
